import axios from 'axios'

export const baseApi=axios.create({baseURL:'https://app.tiger4card.com/api/v1',withCredentials:true})